module.exports = __webpack_public_path__ + "media/dashboard/assets/images/image-off-blue-74379d4ad1089e3b7e9dc60c57c1d470.png";